import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/notification/feed/notification.feed.query.gql"
import type {
  StaffNotificationsQuery,
  StaffNotificationsQueryVariables,
} from "@/v2-backoffice-client/notification/feed/__types__/notification.feed.query"

type Options = QueryHookOptions<
  StaffNotificationsQuery,
  StaffNotificationsQueryVariables
>

export function useStaffNotificationsQuery(options?: Options) {
  return useQuery<StaffNotificationsQuery, StaffNotificationsQueryVariables>(
    query,
    options,
  )
}
